var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSuccessMotivation = function SvgIconSuccessMotivation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4,
    r: 3.5,
    stroke: "#1D1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m2.834 3.909 1.171 1.172 2.162-2.162"
  })));
};
export { SvgIconSuccessMotivation as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOSA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC41IDRDMC41IDEuNzkwODYgMi4yOTA4NiAwIDQuNSAwQzYuNzA5MTQgMCA4LjUgMS43OTA4NiA4LjUgNEM4LjUgNi4yMDkxNCA2LjcwOTE0IDggNC41IDhDMi4yOTA4NiA4IDAuNSA2LjIwOTE0IDAuNSA0WiIgZmlsbD0id2hpdGUiLz4KPGNpcmNsZSBjeD0iNC41IiBjeT0iNCIgcj0iMy41IiBzdHJva2U9IiMxRDFEMUQiLz4KPHBhdGggZD0iTTIuODMzNSAzLjkwOTA0TDQuMDA1MjcgNS4wODA4MUw2LjE2NjgzIDIuOTE5MTYiIHN0cm9rZT0iIzFEMUQxRCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";